module.exports = __webpack_public_path__ + "img/order-empty.67a35e13.png";